import { render, staticRenderFns } from "./firstbinding.vue?vue&type=template&id=46883c2d&scoped=true&"
import script from "./firstbinding.vue?vue&type=script&lang=js&"
export * from "./firstbinding.vue?vue&type=script&lang=js&"
import style0 from "./firstbinding.vue?vue&type=style&index=0&id=46883c2d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46883c2d",
  null
  
)

export default component.exports